<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Keys">Facilities</b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Keys">Keys</b-breadcrumb-item>
            <b-breadcrumb-item :to="{name:'KeyDetails',params:{id:facilitiesKeyId,keyNumber:facilitiesKeyNumber}}">{{facilitiesKeyNumber}}</b-breadcrumb-item>
            <b-breadcrumb-item active>Add Locks</b-breadcrumb-item>
        </b-breadcrumb>

        <form @submit.prevent="onSubmit()">
            <div class="card">
                <div class="bg-dark card-header text-white">Create New Locks</div>
                <div class="card-body">
                  <div class="pb-3">
                      <b>Key Type:</b> {{ facilitiesKeyTypeName }}
                  </div>
                  <AppCardCollapsable :display-footer="false" :is-expanded="true" class="mb-3">
                        <template v-slot:header>Select From Existing Locks</template>
                        <template v-slot:body>
                            <div v-if="!hideLockFor" class="row">
                                <b-form-group class="col-lg-6 col-md-12" label="Search Locks By" v-slot="{ lockForValue }">
                                    <b-form-radio-group
                                      v-model="lockFor"
                                      :options="lockForOptions"
                                      :aria-describedby="lockForValue"
                                      :disabled="!searchEnabled"
                                    ></b-form-radio-group>
                                </b-form-group>
                            </div>
                            <div v-if="lockFor !== 2" class="row">
                                <b-form-group class="col-lg-6 col-md-12" label="Lock Type" v-slot="{ lockTypeValue }">
                                    <b-form-radio-group
                                      v-model="facilitiesLocksFilterOptions.lockType"
                                      :options="lockTypeOptions"
                                      :aria-describedby="lockTypeValue"
                                      :disabled="!searchEnabled"
                                    ></b-form-radio-group>
                                </b-form-group>
                            </div>
                            <div v-if="lockFor !== 2" class="row">
                                <div class="col-lg-6 col-md-12 form-group">
                                    <label for="buildingId">Building</label>
                                    <select :disabled="!searchEnabled" class="form-control" v-model="facilitiesLocksFilterOptions.buildingId">
                                        <option :value="null" disabled>--Select Building--</option>
                                        <option :key="possibleBuilding.id" :value="possibleBuilding.id" v-for="possibleBuilding in possibleBuildings">{{possibleBuilding.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div v-if="lockFor === 1" class="row">
                                <b-form-group class="col-lg-6 col-md-12" label="Room or Suite?" v-slot="{ spaceTypeValue }">
                                    <b-form-radio-group
                                      v-model="spaceType"
                                      :options="spaceTypeOptions"
                                      :aria-describedby="spaceTypeValue"
                                      :disabled="!searchEnabled"
                                    ></b-form-radio-group>
                                </b-form-group>
                            </div>
                            <div class="row">
                                <div v-if="lockFor === 1" class="col-lg-2 col-md-3 form-group">
                                    <label for="spaceIdentity">{{spaceTypeName}} Number</label>
                                    <input  class="form-control"
                                            maxlength="30"
                                            :disabled="!searchEnabled"
                                            v-model="spaceIdentity" />
                                </div>
                                <div class="col-lg-3 col-md-4 form-group">
                                    <label for="lockIdentity">Lock Notes/Name/Location</label>
                                    <input class="form-control"
                                            maxlength="30"
                                            :disabled="!searchEnabled"
                                            v-model="facilitiesLocksFilterOptions.lockIdentity"
                                            :placeholder="lockFor !== 2 ? 'Optional' : ''" />
                                </div>
                            </div>
                            <div class="mb-3 text-left">
                                <button @click.prevent="toggleSearchFields()" class="btn btn-primary d-print-none" :disabled="!canSearch">
                                    {{ searchEnabled ? 'Search' : 'Modify Search' }}
                                </button>
                            </div>
                            <BTable v-if="!searchEnabled"
                                    :busy="isSearching"
                                    :fields="possibleLocksTableFields"
                                    :items="possibleLocks"
                                    :responsive="true"
                                    primary-key="id"
                                    show-empty
                                    striped
                                    table-class="table-align-middle">

                                <template v-slot:cell(id)="row">
                                    <AppCheckBox @change="selectLock(row, $event)" v-model="row.item.isSelected" />
                                </template>
                                <template v-slot:cell(spaceType)="row">
                                    {{row.item.spaceType}} {{row.item.spaceIdentity}}
                                </template>
                                <template v-slot:custom-foot>
                                    <b-tr>
                                        <b-td :colspan="possibleLocksTableFields.length">
                                            <AppTablePagination
                                                    :page.sync="facilitiesLocksFilterOptions.page"
                                                    :pageSize.sync="facilitiesLocksFilterOptions.pageSize"
                                                    :totalCount.sync="facilitiesLocksTotalCount"
                                                    v-on:update:page="loadPossibleLocks()"
                                                    v-on:update:pageSize="loadPossibleLocks()"
                                            ></AppTablePagination>
                                        </b-td>
                                    </b-tr>
                                </template>
                            </BTable>
                        </template>
                  </AppCardCollapsable>
                  <BTable :fields="tableFields"
                          :items="newFacilitiesKeyLocks"
                          :responsive="true"
                          primary-key="id"
                          show-empty
                          striped
                          table-class="table-align-middle">

                      <template v-slot:cell(facilitiesLockId)="row">
                          <button @click.prevent="removeLock(row)" class="btn btn-danger d-print-none">
                              Remove
                          </button>
                      </template>

                      <template v-slot:cell(spaceType)="row">
                          {{row.item.spaceType}} {{row.item.spaceIdentity}}
                      </template>

                      <template v-slot:cell(notes)="row">
                          <textarea class="form-control"
                                    maxlength="1000"
                                    v-model="row.item.notes"/>
                      </template>
                  </BTable>
                </div>
                <div class="card-footer d-print-none text-right">
                    <button :disabled="isSubmitting || rangeEnabled" class="btn btn-primary" type="submit">Save</button>
                    <RouterLink :to="{name:'KeyDetails',params:{id:facilitiesKeyId,keyNumber:facilitiesKeyNumber}}" class="btn btn-danger">Back</RouterLink>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    import AppCheckBox from "@/components/shared/AppCheckBox.vue";
    import AppCardCollapsable from "@/components/shared/AppCardCollapsable.vue";
    import {ToastType} from "@/services/models/shared/ToastType";
    import { FacilitiesKeyType } from "@/services/models/FacilitiesKey";
    import AppTablePagination from "@/components/shared/AppTablePagination";
    import FacilitiesKeysService from "@/services/FacilitiesKeysService";
    import FacilitiesLocksService from "@/services/FacilitiesLocksService";
    import AddressService from "@/services/AddressService";

    export default {
        components: {
          AppCheckBox,
          AppCardCollapsable,
          AppTablePagination
        },
        props: {
            facilitiesKeyId: {
              type: String,
              required: true
            },
            facilitiesKeyNumber: {
              type: String,
              required: true
            },
            facilitiesKeyTypeName: {
              type: String,
              required: true
            },
            facilitiesKeyTypeId: {
              type: String,
              required: true
            }
        },
        data() {
            return {
                hideLockFor: false,
                searchEnabled: true,
                isSearching: false,
                possibleBuildings: [],
                isSubmitting: false,
                isValidating: false,
                possibleLocksTableFields: [
                    {
                        key: 'id',
                        label: '',
                        thStyle: 'width:175px'
                    }, 
                    {
                        key: 'lockType',
                        label: 'Type'
                    },
                    {
                        key: 'buildingName',
                        label: 'Building'
                    },
                    {
                        key: 'spaceType',
                        label: 'Room/Suite',
                    },
                    {
                        key: 'lockIdentity',
                        label: 'Lock Notes/Name/Location',
                    }
                ],
                tableFields: [
                    {
                        key: 'facilitiesLockId',
                        label: ''
                    },
                    {
                        key: 'lockType',
                        label: 'Type'
                    },
                    {
                        key: 'buildingName',
                        label: 'Building'
                    },
                    {
                        key: 'spaceType',
                        label: 'Room/Suite',
                    },
                    {
                        key: 'lockIdentity',
                        label: 'Lock Notes/Name/Location',
                    },
                    {
                        key: 'notes',
                        label: 'Additional Notes'
                    }
                ],
                lockFor: 0,
                lockForOptions: [
                    {
                        value: 0,
                        text: 'Building'
                    },
                    {
                        value: 1,
                        text: 'Room/Suite'
                    },
                    {
                        value: 2,
                        text: 'Other'
                    }
                ],
                lockTypeOptions: [
                    {
                        value: 0,
                        text: 'Other'
                    },
                    {
                        value: 1,
                        text: 'Entrance/Door'
                    }
                ],
                spaceType: 1,
                spaceTypeOptions: [
                    {
                        value: 1,
                        text: 'Room'
                    },
                    {
                        value: 2,
                        text: 'Suite'
                    }
                ],
                spaceIdentity: null,
                facilitiesLocksFilterOptions: {
                  page: 1,
                  pageSize: 10,
                  returnAll: false,
                  lockType: 1,
                  buildingId: null,
                  suite: null,
                  room: null,
                  lockIdentity: null,
                  excludeBuildings: false,
                  excludeBuildingSpaces: true,
                  excludeFacilitiesKeyId: this.facilitiesKeyId
                },
                facilitiesLocksTotalCount: 0,
                possibleLocks: [],
                newFacilitiesKeyLocks: []
            }
        },
        watch: {
            lockFor(newVal) {
                const vm = this;
                
                this.possibleBuildings = [];
                this.buildingId = null;
                this.facilitiesLocksFilterOptions = {
                  page: 1,
                  pageSize: 10,
                  returnAll: false,
                  lockType: 1,
                  buildingId: null,
                  suite: null,
                  room: null,
                  lockIdentity: null,
                  excludeBuildings: false,
                  excludeBuildingSpaces: false,
                  excludeFacilitiesKeyId: this.facilitiesKeyId
                };
                this.spaceType = 1;
                this.spaceIdentity = null;
                AddressService.getAllBuildings()
                    .then(response => {
                        vm.possibleBuildings = response
                    })
                    .catch(error => {
                        vm.alert(ToastType.Danger, error.response.data)
                        vm.$router.replace({name:'KeyDetails',params:{id:vm.facilitiesKeyId,keyNumber:vm.facilitiesKeyNumber}})
                    })
                
                if (newVal === 2) {
                  this.facilitiesLocksFilterOptions.lockType = 0;
                }

                if (newVal === 0) {
                  this.facilitiesLocksFilterOptions.excludeBuildings = false;
                  this.facilitiesLocksFilterOptions.excludeBuildingSpaces = true;
                } else if (newVal === 1) {
                  this.facilitiesLocksFilterOptions.excludeBuildings = true;
                  this.facilitiesLocksFilterOptions.excludeBuildingSpaces = false;
                } else {
                  this.facilitiesLocksFilterOptions.excludeBuildings = true;
                  this.facilitiesLocksFilterOptions.excludeBuildingSpaces = true;
                }
            },

            spaceType (newVal) {
                this.facilitiesLocksFilterOptions.room = null;
                this.facilitiesLocksFilterOptions.suite = null;
                this.spaceIdentity = null;
            },

            spaceIdentity (newVal) {
                const vm = this;

                if (this.spaceType === 1) {
                  this.facilitiesLocksFilterOptions.room = this.spaceIdentity;
                }

                if (this.spaceType === 2) {
                  this.facilitiesLocksFilterOptions.suite = this.spaceIdentity;
                }
            }
        },
        computed: {
          spaceTypeName () {
            const vm = this;
            const spaceTypeName = this.spaceTypeOptions.find(e => { return e.value == vm.spaceType; });
            if (spaceTypeName) {
              return spaceTypeName.text;
            }
            return null;
          },

          canSearch () {
            switch (this.lockFor) {
              case 0:
                return this.facilitiesLocksFilterOptions.buildingId !== null && this.facilitiesLocksFilterOptions.lockType !== null;
              case 1:
                return this.facilitiesLocksFilterOptions.buildingId !== null && this.facilitiesLocksFilterOptions.lockType !== null && (this.facilitiesLocksFilterOptions.suite !== null || this.facilitiesLocksFilterOptions.room !== null);
              case 2:
                return this.facilitiesLocksFilterOptions.lockIdentity !== null;
            }
            return false;
          }
        },
        methods: {
            /**
             * @description Creates a lock and redirects if successful
             */
            onSubmit() {
                const vm = this;

                vm.isSubmitting = true;
                FacilitiesKeysService.addFacilitiesKeyLocks(this.facilitiesKeyId, this.newFacilitiesKeyLocks)
                    .then(() => {
                      vm.alert(ToastType.Success, "The key locks were successfully created");

                      // Redirect to the key detail page
                      vm.$router.replace({name:'KeyDetails',params:{id:vm.facilitiesKeyId,keyNumber:vm.facilitiesKeyNumber}})
                    })
                    .catch((error) => {
                      vm.alert(ToastType.Danger, error.response.data)
                    })
                    .finally(() => {
                      vm.isSubmitting = false;
                    })
            },

            loadPossibleLocks () {
                const vm = this;
                this.isSearching = true;

                FacilitiesLocksService.getFacilitiesLocks(this.facilitiesLocksFilterOptions)
                  .then(response => {
                    vm.possibleLocks = response.data.map(obj => ({ ...obj, isSelected: (vm.newFacilitiesKeyLocks.findIndex(f => {return f.facilitiesLockId === obj.id}) === -1 ? false : true )}));
                    vm.facilitiesLocksTotalCount = response.totalCount;
                  })
                  .catch(error => {
                      vm.alert(ToastType.Danger, error.response.data)
                  })
                  .finally(() => {
                    this.isSearching = false;
                  })
            },

            toggleSearchFields () {
              if (this.searchEnabled) {
                this.searchEnabled = false;
                this.facilitiesLocksFilterOptions.page = 1;
                this.facilitiesLocksFilterOptions.pageSize = 10;
                this.loadPossibleLocks();
              } else {
                this.searchEnabled = true;
                this.possibleLocks = [];
              }
            },

            selectLock (row, isChecked) {
              const indexOfLock = this.newFacilitiesKeyLocks.findIndex(e => { return e.facilitiesLockId === row.item.id });
              if (isChecked && indexOfLock === -1) {
                this.newFacilitiesKeyLocks.push({
                    lockType: row.item.lockType,
                    buildingName: row.item.buildingName,
                    spaceType: row.item.spaceType,
                    spaceIdentity: row.item.spaceIdentity,
                    lockIdentity: row.item.lockIdentity,
                    facilitiesLockId: row.item.id,
                    notes: null,
                    createdByPersonId: this.$store.getters.user.id
                });
              }

              if (!isChecked && indexOfLock > -1) {
                this.newFacilitiesKeyLocks.splice(indexOfLock, 1);
              }
            },

            removeLock (row) {
              const indexOfLock = this.newFacilitiesKeyLocks.findIndex(e => { return e.facilitiesLockId === row.item.facilitiesLockId});
              if (indexOfLock > -1) {
                this.newFacilitiesKeyLocks.splice(indexOfLock, 1);
              }

              if (this.possibleLocks.length > 0) {
                const indexOfPossibleLock = this.possibleLocks.findIndex(e => { return e.id === row.item.facilitiesLockId });
                if (indexOfPossibleLock > -1) {
                  this.possibleLocks[indexOfPossibleLock].isSelected = false;
                }
              }
            }
        },
        created() {
          const vm = this;
          if (this.facilitiesKeyTypeId.toUpperCase() === FacilitiesKeyType['Grand Master']) {
              this.lockFor = 0;
              this.hideLockFor = true;
          } else if (this.facilitiesKeyTypeId.toUpperCase() === FacilitiesKeyType['Suite Master']) {
              this.lockFor = 1;
              this.hideLockFor = true;
          }
          AddressService.getAllBuildings()
              .then(response => {
                  vm.possibleBuildings = response
              })
              .catch(error => {
                  vm.alert(ToastType.Danger, error.response.data)
                  vm.$router.replace({name:'KeyDetails',params:{id:vm.facilitiesKeyId,keyNumber:vm.facilitiesKeyNumber}})
              })
        }
    }
</script>
